import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LocationStoreProvider {


	private db = new DatabaseProvider();
	public locationList: BehaviorSubject<any> = new BehaviorSubject([]);

	constructor() {

	}


	addBatch(locationList) {

		return new Promise((resolve, reject) => {

			this.db.afdelingen.clear().then(() => {

				this.db.afdelingen.bulkAdd(locationList).then((data) => {
					this.loadList();
					resolve(data);
				}).catch((e) => reject(e))

			}).catch((e) => reject(e));

		})

	}

	loadList() {

		return new Promise((resolve, reject) => {

			this.db.afdelingen.toArray().then((data) => {

				this.manipulateList(data).then((list)=>{

					this.locationList.next(list);
					resolve(true)

				}).catch((e)=>reject(e))

			}).catch((e) => reject(e));

		})

	}

	private manipulateList(locationList) {

		return new Promise((resolve, reject) => {

			let list = []

			if (locationList && locationList.length > 0) {

				locationList.forEach((location) => {

					list.push({
						id: location.id,
						name: location.afdelingsnaam
					})

				})

			}

			resolve(list);

		})


	}
}



// WEBPACK FOOTER //
// ./src/providers/location-store/location-store.ts